import React from 'react';
import { Link } from 'react-router-dom';
import './GMPCertificate.css';

const GMPCertificate = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">Quality Certification</div>
            <h1 className="page-title">GMP Certificate (Good Manufacturing Practices)</h1>
            <div className="page-text-content">
              <p>
                Hello Valued Visitors,
              </p>
              <p>
                As NQC (Nova Quality Certification Agency), we take pride in being a professional 
                service provider with extensive experience in certification and documentation. We 
                continue our commitment to providing high-quality services, and today we aim to focus 
                on one of the services we offer: the GMP Certificate.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is GMP?</h2>
            <div className="page-text-content">
              <p>
                GMP stands for "Good Manufacturing Practices," which regulates and supervises 
                production processes in industries like pharmaceuticals, food, and cosmetics. The GMP 
                Certificate ensures that products are manufactured in accordance with quality, safety, 
                and effectiveness standards.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Should You Obtain a GMP Certificate?</h2>
            <div className="reasons-list">
              <div className="reason-item">
                <h3 className="reason-title">1. Quality Assurance</h3>
                <p className="reason-description">
                  The GMP Certificate guarantees that your products meet high-quality standards, 
                  building customer trust and demonstrating your commitment to excellence.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">2. Legal Compliance</h3>
                <p className="reason-description">
                  GMP standards are a legal requirement in many regions for pharmaceuticals, food, and 
                  cosmetics. Having the GMP Certificate helps you avoid legal issues and ensures 
                  compliance with regulations.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">3. Innovation and Continuous Improvement</h3>
                <p className="reason-description">
                  The GMP Certificate demonstrates your business's commitment to continuous improvement 
                  and innovation, enhancing product development and competitive edge.
                </p>
              </div>
              <div className="reason-item">
                <h3 className="reason-title">4. Market Access</h3>
                <p className="reason-description">
                  The GMP Certificate can facilitate your access to international markets. Many 
                  countries prefer products with this certificate, which can help your business grow.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">How to Obtain a GMP Certificate?</h2>
            <div className="page-text-content">
              <p>
                To obtain a GMP Certificate, you need to review your production processes and ensure 
                compliance with GMP standards. As NQC (Nova Quality Certification Agency), we guide 
                you through this process. Our experienced experts provide customized solutions 
                tailored to your business needs and streamline the certification process.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Why Choose NQC (Nova Quality Certification Agency)?</h2>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we provide our customers with the highest 
                quality certification services. With expertise in various fields, including the GMP 
                Certificate, we offer customized solutions tailored to your business needs and 
                effectively manage the certification process.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Final Words</h2>
            <div className="page-text-content">
              <p>
                The GMP Certificate is an important certification that demonstrates that your products 
                meet high-quality and safety standards. We at NQC (Nova Quality Certification Agency) 
                are proud to assist your business in obtaining this valuable certificate. By 
                collaborating with us to provide quality and reliability to your customers, you can 
                help your business grow and gain a competitive advantage.
              </p>
              <p>
                If you have any questions or would like more information about our certification 
                services, our expert team will be happy to assist you.
              </p>
              <p>
                We wish you every success!
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default GMPCertificate;

